import React, { useState } from "react";
import { functions } from "../../firebase";
import { Button } from "../../design/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../design/dialog";
import { Input } from "../../design/input";
import { Field, Fieldset, FieldGroup, Label } from "../../design/fieldset";
import { httpsCallable } from "firebase/functions";
import { Parent } from "@visitproof/types";
import PhoneNumberInput from "../../components/PhoneNumberInput";
import { PencilIcon } from "@heroicons/react/16/solid";

interface Props {
  parent: Parent;
  style?: React.CSSProperties;
}

const UpdateContactInfoButton: React.FC<Props> = ({ parent, style }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(parent.phoneNumber);
  const [email, setEmail] = useState(parent.email);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      console.log({
        parentIt: parent.id,
        email,
        phoneNumber,
      });
      const deactivateSupervisor = httpsCallable(
        functions,
        "updateParentContactInfo",
      );
      const { data } = await deactivateSupervisor({
        parentId: parent.id,
        email,
        phoneNumber,
      });
      console.log(data);
      setIsOpen(false);
    } catch (error) {
      alert("Failed to upload file. Please try again later.");
    }
    setIsSubmitting(false);
  };

  const clearForm = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button
        outline
        type="button"
        onClick={() => setIsOpen(true)}
        style={style}
      >
        <PencilIcon className="w-4 h-4" />
      </Button>
      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogTitle>Contact Info</DialogTitle>
        <DialogBody>
          <Fieldset>
            <FieldGroup>
              <Field>
                <Label>Phone Number</Label>
                <PhoneNumberInput
                  defaultValue={phoneNumber ?? ""}
                  value={phoneNumber ? phoneNumber.toString().slice(-14) : ""}
                  onChange={setPhoneNumber}
                />
              </Field>
              <Field>
                <Label>Email</Label>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Field>
            </FieldGroup>
          </Fieldset>
        </DialogBody>
        <DialogActions>
          <Button plain onClick={clearForm}>
            Cancel
          </Button>
          <Button disabled={isSubmitting} onClick={handleSubmit}>
            {isSubmitting ? "Updating..." : "Update"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UpdateContactInfoButton;
